import React from 'react';
import PropTypes from 'prop-types';
import css from './NavigationButton.css';
import MaterialIcon from 'SF/MaterialIcon';

export default class NavigationButton extends React.Component {

  render() {
    return (
      <div
        className={css['button']}
        onClick={this.props.onClick}
        aria-label="Open navigation menu"
        role="button"
        tabIndex="0"
        id="main-navigation-button"
        aria-expanded={this.props.isExpanded || false}>
        <MaterialIcon icon='menu' />
      </div>
    );
  }
}

NavigationButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool
};
